import { LocaleContext, LocaleLangE } from "../../i18n/LocaleContext";
import { useContext } from "react";

export const useLocale = () => {
  const { locale, setLocale } = useContext(LocaleContext);
  const isRus = locale === LocaleLangE.RU;
  return { locale, isRus, setLocale };
};
